import * as moment from 'moment';
import { Salle } from './salle.model';
import { Animateur } from './animateur.model';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class CommissionAgenda {
    static jsonMap = {
        id: 'id',
        terminee: 'terminee',
        debut: { key: 'dateDebut', converter: new DateTimeConverter() },
        fin: { key: 'dateFin', converter: new DateTimeConverter() },
        numero: 'numeroCommission',
        salle: { key: 'idSalle', converter: new (DataIdConverterFactory.build(Salle, 'salles'))() },
        animateur: { key: 'idAnimateur', converter: new (DataIdConverterFactory.build(Animateur, 'animateurs'))() },
        nbJuresInscrits: 'nbJuresInscrits',
        nbJuresPresents: 'nbJuresPresents',
        nbJuresTotal: 'nbJuresTotal',
        nbEchantillons: 'nbEchantillons'
    };

    id: number;
    terminee: boolean;
    debut: moment.Moment;
    fin: moment.Moment;
    numero: string;
    salle: Salle;
    animateur: Animateur;
    nbJuresInscrits: number;
    nbJuresPresents: number;
    nbJuresTotal: number;
    nbEchantillons: number;
}
